import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { EstateJobMappingListingSchemaObject } from '../EstateJobMappingSchema';
import { validate } from "../../Common";
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const screenCode = 'ESTATEJOBMAPPING';

export function EstateJobMappingListing(props) {
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [cropTypes, setCropTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [availableJobs, setAvailableJobs] = useState([]);
    const [mappedJobs, setMappedJobs] = useState([]);
    const [initialMappedJobs, setInitialMappedJobs] = useState([]);
    const [selectedAvailableJobs, setSelectedAvailableJobs] = useState([]);
    const [selectedMappedJobs, setSelectedMappedJobs] = useState([]);
    const [selectAllAvailable, setSelectAllAvailable] = useState(false);
    const [selectAllMapped, setSelectAllMapped] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save success"
    });
    const [isEnable, setIsEnable] = useState(true);
    const [estateJobMappingData, setEstateJobMappingData] = useState({
        groupID: '0',
        operationEntityID: '0',
        cropTypeID: '0'
    });

    const schema = Joi.object(EstateJobMappingListingSchemaObject).options({ allowUnknown: true });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);
    useEffect(() => {
        getAllGroups();
        getPermissions();
    }, []);

    useEffect(() => {
        if (allowedOperationEntities.length > 0) {
            const estatesFromToken = {};
            allowedOperationEntities.forEach(entity => {
                estatesFromToken[entity.OperationEntityID] = entity.OperationEntityName;
            });
            setEstates(estatesFromToken);
        }
    }, [allowedOperationEntities]);

    useEffect(() => {
        if (estateJobMappingData.operationEntityID !== '0') {
            GetAllCropTypesForDropdown();
        } else {
            setCropTypes([]);
        }
    }, [estateJobMappingData.operationEntityID]);

    useEffect(() => {
        const loadAllJobs = async () => {
            if (estateJobMappingData.cropTypeID === '0') {
                setAvailableJobs([]);
                setMappedJobs([]);
                setInitialMappedJobs([]);
                return;
            }

            try {
                const [allJobs, mappedJobsData] = await Promise.all([
                    services.GetAllJobsByOperationEntity(
                        estateJobMappingData.operationEntityID,
                        estateJobMappingData.cropTypeID
                    ),
                    services.GetMappedJobsByCropType({
                        operationEntityID: parseInt(estateJobMappingData.operationEntityID),
                        cropTypeID: parseInt(estateJobMappingData.cropTypeID)
                    })
                ]);

                const mappedTaskIds = (mappedJobsData || []).map(j => j.taskID);
                const availableJobsFiltered = (allJobs || []).filter(
                    j => !mappedTaskIds.includes(j.taskID)
                );

                setMappedJobs(mappedJobsData || []);
                setInitialMappedJobs(mappedJobsData || []);
                setAvailableJobs(availableJobsFiltered);
            } catch (error) {
                console.error('Error loading jobs:', error);
                setAvailableJobs([]);
                setMappedJobs([]);
                setInitialMappedJobs([]);
            }
        };

        loadAllJobs();
    }, [estateJobMappingData.operationEntityID, estateJobMappingData.cropTypeID]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        validateInputs(e.target);

        const updates = { [name]: value };

        if (name === "groupID") {
            updates.operationEntityID = '0';
            updates.cropTypeID = '0';
        } else if (name === "operationEntityID") {
            updates.cropTypeID = '0';
        }

        setEstateJobMappingData(prev => ({ ...prev, ...updates }));

        setSelectedAvailableJobs([]);
        setSelectedMappedJobs([]);
        setSelectAllAvailable(false);
        setSelectAllMapped(false);
    };

    function handleAvailableJobSelect(taskID) {
        setSelectedAvailableJobs(prev => {
            if (prev.includes(taskID)) {
                return prev.filter(id => id !== taskID);
            } else {
                return [...prev, taskID];
            }
        });
    }

    function handleMappedJobSelect(taskID) {
        setSelectedMappedJobs(prev => {
            if (prev.includes(taskID)) {
                return prev.filter(id => id !== taskID);
            } else {
                return [...prev, taskID];
            }
        });
    }

    function handleSelectAllAvailable(e) {
        setSelectAllAvailable(e.target.checked);
        if (e.target.checked) {
            setSelectedAvailableJobs(availableJobs.map(j => j.taskID));
        } else {
            setSelectedAvailableJobs([]);
        }
    }

    function handleSelectAllMapped(e) {
        setSelectAllMapped(e.target.checked);
        if (e.target.checked) {
            setSelectedMappedJobs(mappedJobs.map(j => j.taskID));
        } else {
            setSelectedMappedJobs([]);
        }
    }

    function handleMoveToMapped() {
        if (selectedAvailableJobs.length === 0) return;

        const jobsToMove = availableJobs.filter(j => selectedAvailableJobs.includes(j.taskID));
        setMappedJobs(prev => [...prev, ...jobsToMove]);
        setAvailableJobs(prev => prev.filter(j => !selectedAvailableJobs.includes(j.taskID)));
        setSelectedAvailableJobs([]);
        setSelectAllAvailable(false);
    }

    function handleMoveToAvailable() {
        if (selectedMappedJobs.length === 0) return;

        const jobsToMove = mappedJobs.filter(j => selectedMappedJobs.includes(j.taskID));
        setAvailableJobs(prev => [...prev, ...jobsToMove]);
        setMappedJobs(prev => prev.filter(j => !selectedMappedJobs.includes(j.taskID)));
        setSelectedMappedJobs([]);
        setSelectAllMapped(false);
    }

    async function handleSave() {
        const errorMessages = validate(schema, estateJobMappingData);
        if (errorMessages) {
            setErrors(errorMessages);
            return;
        }

        const initialTaskIds = initialMappedJobs.map(j => j.taskID).sort();
        const currentTaskIds = mappedJobs.map(j => j.taskID).sort();

        const hasChanges = initialTaskIds.length !== currentTaskIds.length ||
            !initialTaskIds.every((id, index) => id === currentTaskIds[index]);

        if (!hasChanges) {
            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: "No changes detected. Please make changes before saving"
            });
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 3000);
            return;
        }

        const initialTaskIdsSet = new Set(initialMappedJobs.map(j => j.taskID));
        const currentTaskIdsSet = new Set(mappedJobs.map(j => j.taskID));

        const addedJobs = mappedJobs.filter(j => !initialTaskIdsSet.has(j.taskID));
        const removedJobs = initialMappedJobs.filter(j => !currentTaskIdsSet.has(j.taskID));

        const saveData = {
            groupID: parseInt(estateJobMappingData.groupID),
            operationEntityID: parseInt(estateJobMappingData.operationEntityID),
            cropTypeID: parseInt(estateJobMappingData.cropTypeID),
            jobIDs: mappedJobs.map(j => j.labourTaskID),
            taskIDs: mappedJobs.map(j => j.taskID),
            createdBy: tokenService.getUserDetailsFromTokenV2().id
        };

        const response = await services.SaveEstateJobMapping(saveData);

        if (response.statusCode === "Success") {
            setInitialMappedJobs([...mappedJobs]);

            let successMessage = "";

            if (addedJobs.length > 0 && removedJobs.length === 0) {
                successMessage = `${addedJobs.length} job${addedJobs.length > 1 ? 's' : ''} successfully mapped.`;
            } else if (removedJobs.length > 0 && addedJobs.length === 0) {
                successMessage = `${removedJobs.length} job${removedJobs.length > 1 ? 's' : ''} successfully removed.`;
            } else {
                successMessage = `${addedJobs.length} job${addedJobs.length > 1 ? 's' : ''} mapped and ${removedJobs.length} job${removedJobs.length > 1 ? 's' : ''} removed.`;
            }

            setMessageModel({
                hidden: false,
                type: "Success",
                disciption: successMessage
            });
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 3000);
        } else {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: response.message || "Failed to save mapping"
            });
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 5000);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWESTATEJOBMAPPING');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || []);
        setEstateJobMappingData({
            ...estateJobMappingData,
            groupID: token.groupID.toString(),
            operationEntityID: token.operationEntityID.toString()
        });
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        const estatesFromToken = {};
        allowedOperationEntities.forEach(entity => {
            estatesFromToken[entity.OperationEntityID] = entity.OperationEntityName;
        });

        setEstates(estatesFromToken);
    }

    async function GetAllCropTypesForDropdown() {
        const data = await services.GetAllCropTypes();
        setCropTypes(data);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Estate Job Mapping"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                                            value={estateJobMappingData.groupID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!isEnable || !permissionList.isOperationEntityFilterEnabled}
                                            value={estateJobMappingData.operationEntityID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="cropTypeID">Crop Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="cropTypeID"
                                            id="cropTypeID"
                                            name="cropTypeID"
                                            value={estateJobMappingData.cropTypeID}
                                            disabled={!isEnable}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Crop Type--</MenuItem>
                                            {generateDropDownMenu(cropTypes)}
                                        </Select>
                                        {errors["cropTypeID"] && <FormHelperText error>{errors["cropTypeID"]}</FormHelperText>}
                                    </div>
                                </div>

                                {estateJobMappingData.operationEntityID !== '0' && estateJobMappingData.cropTypeID !== '0' && (
                                    <Box mt={4} p={3} border={1} borderColor="grey.300" borderRadius={2}>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <h5 style={{ color: '#2e7d32', fontWeight: 'bold', marginBottom: '20px' }}>Jobs</h5>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selectAllAvailable}
                                                            onChange={handleSelectAllAvailable}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Select All"
                                                />
                                                <div style={{
                                                    maxHeight: '400px',
                                                    overflowY: 'auto',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    {availableJobs.length === 0 ? (
                                                        <p style={{ textAlign: 'center', color: '#666' }}>No jobs available</p>
                                                    ) : (
                                                        availableJobs.map((job) => (
                                                            <FormControlLabel
                                                                key={job.taskID}
                                                                control={
                                                                    <Checkbox
                                                                        checked={selectedAvailableJobs.includes(job.taskID)}
                                                                        onChange={() => handleAvailableJobSelect(job.taskID)}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={job.taskName}
                                                                style={{ display: 'block', marginBottom: '5px' }}
                                                            />
                                                        ))
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-2" style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                                gap: '20px',
                                                paddingTop: '68px'
                                            }}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleMoveToMapped}
                                                    disabled={selectedAvailableJobs.length === 0}
                                                    style={{ minWidth: '60px' }}
                                                >
                                                    <ArrowForwardIcon />
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleMoveToAvailable}
                                                    disabled={selectedMappedJobs.length === 0}
                                                    style={{ minWidth: '60px' }}
                                                >
                                                    <ArrowBackIcon />
                                                </Button>
                                            </div>

                                            <div className="col-md-5">
                                                <h5 style={{ color: '#2e7d32', fontWeight: 'bold', marginBottom: '20px' }}>Mapped Jobs</h5>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selectAllMapped}
                                                            onChange={handleSelectAllMapped}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Select All"
                                                />
                                                <div style={{
                                                    maxHeight: '400px',
                                                    overflowY: 'auto',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    {mappedJobs.length === 0 ? (
                                                        <p style={{ textAlign: 'center', color: '#666' }}>No mapped jobs</p>
                                                    ) : (
                                                        mappedJobs.map((job) => (
                                                            <FormControlLabel
                                                                key={job.taskID}
                                                                control={
                                                                    <Checkbox
                                                                        checked={selectedMappedJobs.includes(job.taskID)}
                                                                        onChange={() => handleMappedJobSelect(job.taskID)}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={job.taskName}
                                                                style={{ display: 'block', marginBottom: '5px' }}
                                                            />
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <Box mt={3} display="flex" justifyContent="flex-end">
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: '#4caf50',
                                                    color: 'white',
                                                    padding: '10px 40px',
                                                    fontSize: '16px'
                                                }}
                                                onClick={handleSave}
                                            >
                                                Save
                                            </Button>
                                        </Box>
                                    </Box>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}